<template lang="pug">
.shop-info#shop-info
  el-form.shop-info(:model="shopInfo" label-width="120px")
    el-form-item(label="店铺编码：" v-if="shopInfo.id")
      span {{shopInfo.id}}

    el-form-item(label="店铺名称：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      span(v-if="$store.state.shop.type === 'query'") {{shopInfo.shopName}}
      el-input(placeholder="请输入店铺名称" v-model="shopData.shopName" maxlength="20" v-if="$store.state.shop.type === 'edit'")

    el-form-item(label="店铺类型：" )
      span(v-if="shopInfo.type === 10") 自营店铺
      span(v-if="shopInfo.type === 20") 直销店铺
      span(v-if="shopInfo.type === 30") 联营店铺

    el-form-item.shop-logo-upload(label="营业执照：")
      img.logo(v-if="shopInfo.businessLicense"  v-preview
        :src="`${FILE_ACCESS_PRIVATE}${shopInfo.businessLicense}&_tk=${getWebToken()}`")

    el-form-item.shop-logo-upload(label="店铺logo：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      img.logo(v-if="shopInfo.logo && $store.state.shop.type === 'query'"  v-preview
        :src="FILE_ROOT + shopInfo.logo + '?x-oss-process=image/resize,m_lfit,h_200,w_200'")
      el-upload(:on-success="handleSuccess" :before-upload="beforeUpload" v-if="$store.state.shop.type === 'edit'"
        :action="UPLOAD_ROOT" accept="image/jpeg, image/jpg, image/png" :show-file-list="false")
        i.el-icon-plus(v-if="!shopData.logo")
        img.logo(v-if="shopData.logo && shopLogoSuccess" :src="FILE_ROOT + shopData.logo + '?x-oss-process=image/resize,m_lfit,h_200,w_200'")
        .tip 点击更换logo
      span.c-9(v-if="$store.state.shop.type === 'edit'") 格式：图片尺寸300 * 300 jpg, png格式，大小为1M以内

    el-form-item(label="主营业务：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      span(v-if="$store.state.shop.type === 'query'") {{shopInfo.businessScope}}
      el-input(placeholder="请输入店铺主营业务" v-model="shopData.businessScope" v-if="$store.state.shop.type === 'edit'"
        type="textarea" :rows="2" maxlength="30")

    el-form-item(label="设置客服：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      .service-count
        span(v-if="isHasService") 已设置{{serviceCount}}名客服
        el-button.ml-30(type="primary" v-if="$store.state.shop.type === 'edit' && isHasService" @click="$router.push('/shop/customerService')") 设置更多客服
      .add-service(v-if="$store.state.shop.type === 'edit' && !isHasService")
        el-input.phone-input( v-model.trim="userPhone" placeholder="请输入添加用户手机号" :maxlength="11")
        el-button(type="primary" @click="queryUserInfo") 添加客服
        .user-list
          el-tag.mr-10(v-for="item, index in userList" :key="item.id"
            closable @close="userList.splice(index, 1)") {{item.name || item.nickname}}

    el-form-item(label="所在地区：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      span(v-if="$store.state.shop.type === 'query'") {{shopInfo.province}} {{shopInfo.province === shopInfo.city ? '' : shopInfo.city}}
      el-select(v-model="shopData.provinceCode" placeholder="选择省份" @change="changeProvince" v-if="$store.state.shop.type === 'edit'")
        el-option(v-for="item in provinces" :key="item.provinceCode" :label="item.provinceName" :value="item.provinceCode")
      el-select(v-model="shopData.cityCode" placeholder="选择城市" v-if="$store.state.shop.type === 'edit'" @change="changeCity")
        el-option(v-for="item in cities" :key="item.cityCode" :label="item.cityName" :value="item.cityCode") {{item.cityName}}

    el-form-item(label="订单付款时间：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      span.mr-10(v-if="$store.state.shop.type === 'query'") {{timeForMat()}}
      el-select(v-model="shopConfig.paymentOvertime" placeholder="选择付款时间" v-if="$store.state.shop.type === 'edit'")
        el-option(label="30分钟" :value="30")
        el-option(label="1小时" :value="60")
        el-option(label="2小时" :value="120")
        el-option(label="4小时" :value="240")
        el-option(label="8小时" :value="480")
        el-option(label="24小时" :value="1440")
        el-option(label="48小时" :value="2880")

    el-form-item(label="开票时间：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      span.mr-10(v-if="shopConfig.invoiceDay && $store.state.shop.type === 'query'")
        | {{`每月${shopConfig.invoiceDay}号前${shopConfig.invoiceTrigger === 1 ? '付款完成' : shopConfig.invoiceTrigger === 2 ? '货物交割结算' : ''},`}}
        | {{`${shopConfig.invoiceCycle === 1 ? '当月' : '隔月'}`}}开具发票
      span.mr-10(v-if="!shopConfig.invoiceDay && $store.state.shop.type === 'query'") 无
      span(v-if="$store.state.shop.type === 'edit'") 每月
      el-input.width-80(v-model="shopConfig.invoiceDay" @input="onlyInteger" v-if="$store.state.shop.type === 'edit'")
      span.mr-10(v-if="$store.state.shop.type === 'edit'") 号前
      el-select.mr-10(v-model="shopConfig.invoiceTrigger" placeholder="选择开票时间" v-if="$store.state.shop.type === 'edit'")
        el-option(:value="0" label="请选择") 请选择
        el-option(:value="1" label="付款完成") 付款完成
        el-option(:value="2" label="货物交割结算") 货物交割结算
      el-select.mr-10(v-model="shopConfig.invoiceCycle" placeholder="选择开票时间" v-if="$store.state.shop.type === 'edit'")
        el-option(label="当月" :value="1")
        el-option(label="隔月" :value="2")
      span(v-if="$store.state.shop.type === 'edit'") 开具发票

    el-form-item(label="开票类型：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      el-checkbox(:label="item.pValue" :key="item.pValue" v-for="item in shopConfig.invoiceType"
        v-model="item.checked" :disabled="$store.state.shop.type === 'query'") {{item.pText}}

    el-form-item(label="支付方式：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      el-checkbox(:label="item.pValue" :key="item.pValue" v-for="item in shopConfig.usablePayments"
        v-model="item.checked" :disabled="$store.state.shop.type === 'query'") {{item.pText}}

    el-form-item(label="服务标签：")
      el-checkbox(:label="item.pValue" :key="item.pValue" v-for="item in shopConfig.serviceTag"
        v-model="item.checked" :disabled="$store.state.shop.type === 'query'") {{item.pText}}

    el-form-item(label="配送类型：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      el-checkbox(:label="item.pValue" :key="item.pValue" v-for="item in shopConfig.deliveryType"
        v-model="item.checked" :disabled="$store.state.shop.type === 'query'") {{item.pText}}

    el-form-item(label="物流配送：")
      //- 请求完成再开始初始化
      freight-set(
        ref="freight-set"
        :is-show="$store.state.shop.type === 'query'"
        :freight-id="shopConfig.transportTemplateId"
        @change="onChangeTransportTemplate"
      )

    el-form-item(label="结算设置：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      el-radio-group(v-model="shopConfig.settleType" :disabled="$store.state.shop.type === 'query'")
        el-radio(label="A_SINGLE_DISCUSSION") 一单一议(订单内全部商品确认收货后，自动根据实提数据生成结算单)
        el-radio(label="CREATE_MANUALLY") 手动创建(由卖家自主手动勾选商品生成结算单)


    el-form-item#shopTimeConfig(label="营业时间：" :rules="[ { required: $store.state.shop.type === 'edit' } ]")
      .auto-open
        el-checkbox(v-model="shopConfig.autoOpen" :disabled="$store.state.shop.type === 'query'") 自动开店(勾选自动开店后，系统将按照设置时间自动开店)
      el-table(:data="$store.state.shop.shopTimeList"  style="width: 500px" border size="small"
        :header-cell-style="{ padding: 0 }" v-if="$store.state.shop.type === 'query'")
        el-table-column(label="是否营业" align="center" v-if="shopConfig.autoOpen")
          template(slot-scope="scope")
            span(v-if="scope.row.isOpen") 营业
            span(v-if="!scope.row.isOpen") 不营业
        el-table-column(label="时间" align="center")
          template(slot-scope="scope")
            span 周{{'一二三四五六日'.charAt(scope.row.weekDay - 1)}}
        el-table-column(label="开始时间" align="center")
          template(slot-scope="scope")
            el-time-picker.w-100(v-model="scope.row.openTime" value-format="HH:mm" size="mini" format="HH:mm"
              placeholder="开始时间" :picker-options="{ format: 'HH:mm' }"  :readonly="$store.state.shop.type === 'query'"
              v-if="shopConfig.autoOpen")
            span(v-else) 手动开店
        el-table-column(label="关店时间" align="center")
          template(slot-scope="scope")
           el-time-picker.w-100(v-model="scope.row.closeTime" value-format="HH:mm" size="mini" format="HH:mm"
            placeholder="结束时间" :picker-options="{ format: 'HH:mm' }"  :readonly="$store.state.shop.type === 'query'")

      el-table(:data="$store.state.shop.shopTimeList"  style="width: 505px" border size="small"
        :header-cell-style="{ padding: 0 }" v-if="$store.state.shop.type === 'edit'")
        el-table-column(label="是否营业" align="center" v-if="shopConfig.autoOpen")
          template(slot-scope="scope")
            el-checkbox.checkbox(v-model="scope.row.isOpen" :disabled="$store.state.shop.type === 'query'") 营业
        el-table-column(label="时间" align="center")
          template(slot-scope="scope")
            span 周{{'一二三四五六日'.charAt(scope.row.weekDay - 1)}}
        el-table-column(label="开始时间" align="center")
          template(slot-scope="scope")
            el-time-picker.w-100(:clearable="false" :editable="false" v-model="scope.row.openTime" value-format="HH:mm" size="mini" format="HH:mm" :readonly="$store.state.shop.type === 'query'"
              placeholder="开始时间" :picker-options="{ format: 'HH:mm', selectableRange: `00:00:00 - ${scope.row.closeTime}:59` }" v-if="shopConfig.autoOpen")
            span(v-else) 手动开店
        el-table-column(label="关店时间" align="center")
          template(slot-scope="scope")
            el-time-picker.w-100(:clearable="false" :editable="false" v-model="scope.row.closeTime" value-format="HH:mm" size="mini" format="HH:mm" :readonly="$store.state.shop.type === 'query'"
              placeholder="结束时间" :picker-options="{ format: 'HH:mm', selectableRange: `${scope.row.openTime}:00 - 23:59:59` }")

    el-form-item(label="店铺介绍：")
      ul.detail(v-if="$store.state.shop.type === 'query'")
        li(v-for="item, index in shopDetail" :key="index")
          img(:src="FILE_ROOT + item.value" v-if="item.type === 'IMAGE'" v-preview)
          .content(v-if="item.type === 'COMENT'" v-html="item.value")
      editor(v-model="shopDetail" v-if="$store.state.shop.type === 'edit'")
    .operate
      el-button.w-200(type="primary" @click="$store.dispatch('updateShopDataType', 'edit')" v-if="$store.state.shop.type === 'query'") 修改店铺信息
      el-button(@click="$store.dispatch('updateShopDataType', 'query')"  v-if="$store.state.shop.type === 'edit'") 取 消
      el-button(type="primary" @click="submit"  v-if="$store.state.shop.type === 'edit'") 保 存

</template>

<script>
import { FILE_ROOT, UPLOAD_ROOT, FILE_ACCESS_PRIVATE } from '@/common/constants/'
import editor from '@/components/editor/editor'
import freightSet from '@/components/form/freightSet'
import { getWebToken } from '@/common/utils/common'

export default {
  name: 'shopInfo',
  data() {
    return {
      shopData: {
        provinceCode: '110000',
        cityCode: '',
        shopName: '',
        businessScope: ''
      } /** 店铺信息 */,
      shopInfo: {},
      FILE_ROOT,
      UPLOAD_ROOT,
      FILE_ACCESS_PRIVATE,
      getWebToken,
      getDataCount: 0,
      shopDetail: [],
      userPhone: '',
      userList: [],
      provinces: [],
      cities: [],
      shopConfig: {
        autoOpen: false,
        paymentOvertime: 240,
        invoiceCycle: 1,
        invoiceDay: '',
        invoiceTrigger: '',
        invoiceType: [],
        serviceTag: [],
        deliveryType: [],
        transportTemplateId: 0,
        settleType: '',
        usablePayments: []
      },
      isHasService: false,
      shopLogoSuccess: true,
      serviceCount: 0
    }
  },
  components: {
    editor,
    freightSet
  },
  created() {
    this.getShopInfo()
    this.getProvinces()
  },
  activated() {
    if (this.$store.state.shop.type === 'edit') {
      document.querySelector('main').scrollTop = 490
    }
    this.$refs['freight-set'].getList() // 重新获取运费模版
    this.getServiceList()
  },
  destroyed() {
    this.$store.dispatch('updateShopDataType', 'query')
  },
  methods: {
    /** 获取店铺信息 */
    async getShopInfo() {
      try {
        const result = await this.$get('shop.adminGetCurrentShop')
        if (result.success) {
          this.shopInfo = JSON.parse(JSON.stringify(result.data[0]))
          this.shopData = Object.assign(this.shopData, result.data[0])
          this.$store.dispatch('setShopInfo', result.data[0])
          delete this.shopData.shopConfig
          this.shopConfig = this.shopInfo.shopConfig
            ? Object.assign(this.shopConfig, this.shopInfo.shopConfig)
            : this.shopConfig
          this.shopConfig.invoiceCycle = !this.shopConfig.invoiceCycle
            ? 1
            : this.shopConfig.invoiceCycle
          this.shopConfig.invoiceDay = !this.shopConfig.invoiceDay ? '' : this.shopConfig.invoiceDay
          this.shopConfig.paymentOvertime = !this.shopConfig.paymentOvertime
            ? 240
            : this.shopConfig.paymentOvertime
          this.autoOpen = this.shopConfig.autoOpen
          console.log(this.shopConfig)
          if (this.shopInfo.id) {
            this.getCities()
            this.getPictureText(this.shopData.id)
          } else {
            this.$store.dispatch('updateShopDataType', this.getDataCount === 0 ? 'edit' : 'query')
            this.shopData.cityCode = ''
            this.shopData.provinceCode = ''
          }
          this.getDataCount++
          if (this.$store.state.shop.type === 'edit') {
            document.querySelector('main').scrollTop = 750
          }
        }
      } catch (err) {
        console.log(err)
      }
      this.getServiceList()
    },
    /** 获取当前店铺客服信息 */
    async getServiceList() {
      let isHasServiceCopy = this.isHasService
      try {
        const result = await this.$get('shop.adminCurrentShopCustomerService')
        if (result.success) {
          this.isHasService =
            result.data[0].customerServices && result.data[0].customerServices.length > 0
          this.serviceCount =
            result.data[0].customerServices && result.data[0].customerServices.length
          if (!this.isHasService && isHasServiceCopy) {
            this.userList = []
            this.userPhone = ''
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 修改店铺信息 */
    async submit() {
      const { shopName, logo, businessScope } = this.shopData,
        {
          invoiceTrigger,
          invoiceDay,
          invoiceType,
          deliveryType,
          transportTemplateId,
          settleType
        } = this.shopConfig
      if (!shopName) {
        return this.$message.error('请输入店铺名称')
      }
      if (!logo) {
        return this.$message.error('请输入上传店铺logo')
      }
      if (!businessScope) {
        return this.$message.error('请输入店铺主营业务')
      }
      if (!invoiceTrigger) {
        return this.$message.error('请选择开票时间')
      }
      if (!Number(invoiceDay)) {
        return this.$message.error('请输入开票时间')
      }
      if (invoiceDay > 31) {
        return this.$message.error('开票时间不可以大于31')
      }
      if (!this.userList[0] && !this.isHasService) {
        return this.$message.error('请先设置客服信息')
      }
      if (!settleType) {
        return this.$message.error('请选择结算设置')
      }
      let isHasInvoiceType = false
      invoiceType &&
        invoiceType.forEach(item => {
          isHasInvoiceType = item.checked ? true : isHasInvoiceType
        })
      if (!isHasInvoiceType) {
        return this.$message.error('请选择开票类型')
      }
      let isHasDeliveryType = false
      deliveryType &&
        deliveryType.forEach(item => {
          isHasDeliveryType = item.checked ? true : isHasDeliveryType
        })
      if (!isHasDeliveryType) {
        return this.$message.error('请选择配送类型')
      }
      if (!transportTemplateId) {
        const isChecked = this.$refs['freight-set'].getIsChecked()
        if (isChecked) {
          return this.$message.error('请选择运费模版')
        }
      }
      try {
        let openingHours = JSON.parse(JSON.stringify(this.$store.state.shop.shopTimeList))
        const result = await this.$post('shop.adminAddOrEditCurrentShop', {
          shopAddInfo: this.shopData,
          shopConfig: Object.assign(this.shopConfig, {
            openingHours
          }),
          shopMemberAddInfo: this.isHasService
            ? ''
            : {
                userId: (this.userList[0] && this.userList[0].id) || '',
                type: 'CUSTOMER_SERVICE',
                showSort: 0
              }
        })
        if (result.success) {
          result.data[0].id && this.addPictureText2Shop(result.data[0].id)
          this.$store.dispatch('updateShopDataType', 'query')
        }
      } catch (err) {
        this.$message.error('店铺信息修改失败')
        console.log(err)
      }
    },
    /** 上传图片成功 */
    handleSuccess(response, file) {
      this.shopLogoSuccess = false
      const logo = response.data || file.response.data
      this.shopLogoSuccess = true
      console.log(logo)
      this.$set(this.shopData, 'logo', logo)
      console.log(this.shopData.logo)
    },
    /** 上传图片钱验证信息 */
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt1M = file.size / 1024 / 1024 < 1
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!')
      }
      if (!isLt1M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
      }
      return isJPG && isLt1M
    },
    /** 获取图文详情列表*/
    async getPictureText(outId) {
      try {
        const result = await this.$post('comcenter.getPictureTextInfo', {
          outId,
          outType: 'SHOP'
        })
        if (result.success) {
          this.shopDetail = result.data[0].pictureTextList || []
        }
      } catch (err) {
        this.$message.error('获取店铺详情失败')
        console.log(err)
      }
    },
    /** 添加图文详情 */
    async addPictureText2Shop(id) {
      try {
        //店铺新增或者修改成功后，需要重新刷新下店铺列表
        this.$store.dispatch('user/getShopInfoList')
        const result = await this.$post('comcenter.addPictureText', {
          poictureTextListQuery: {
            pictureTextItemInfoList: this.shopDetail.length === 0 ? [{}] : this.shopDetail,
            outType: 'SHOP',
            outId: id
          }
        })
        if (result.data[0].value) {
          this.shopDetail = []
        }
        this.getShopInfo()
      } catch (err) {
        this.getShopInfo()
        this.$message.error('添加店铺详情失败')
        console.log(err)
      }
    },
    /** 获取省 */
    async getProvinces() {
      try {
        const result = await this.$post('user.getProvinces', {
          provinceCode: ''
        })
        if (result.success) {
          this.provinces = result.data[0].value || []
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 修改省份 */
    changeProvince() {
      this.getCities()
      this.provinces &&
        this.provinces.forEach(item => {
          if (item.provinceCode === this.shopData.provinceCode) {
            this.shopData.province = item.provinceName
          }
        })
      this.shopData.cityCode = ''
      this.shopData.city = ''
    },
    /** 修改城市 */
    changeCity() {
      this.cities &&
        this.cities.forEach(item => {
          if (item.cityCode === this.shopData.cityCode) {
            this.shopData.city = item.cityName
          }
        })
    },
    /** 获取市 */
    async getCities() {
      try {
        const result = await this.$post('user.getCities', {
          fatherCode: this.shopData.provinceCode || '110000'
        })
        if (result.success) {
          this.cities = result.data[0].value || []
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 格式化店铺付款时间 */
    timeForMat() {
      let result = ''
      if (this.shopConfig.paymentOvertime) {
        let hh = Math.floor(this.shopConfig.paymentOvertime / 60) || 0
        let mm = this.shopConfig.paymentOvertime - hh * 60
        result = hh > 0 ? result + `${hh}小时` : result
        result = mm > 0 ? result + `${mm}分钟` : result
      }
      return result
    },
    /** 只能是整数 */
    onlyInteger() {
      try {
        this.shopConfig.invoiceDay = this.shopConfig.invoiceDay.replace(/[^\d]/g, '') || ''
      } catch (e) {
        this.shopConfig.invoiceDay = 0
      }
    },
    /** 查询客服的名字 */
    async queryUserInfo() {
      try {
        const result = await this.$post('user.getUserInfoByMobileNo', {
          mobileNo: this.userPhone
        })
        if (result.success) {
          this.userList = [result.data[0]]
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 修改运费模版
    onChangeTransportTemplate(id) {
      this.shopConfig.transportTemplateId = id
    }
  }
}
</script>

<style lang="stylus" scoped>
.shop-info
  span
    font-size 14px

  .width-80
    width 80px
    margin 0 10px

  /deep/.el-form-item__label
    font-size 14px
  .shop-logo-upload
    /deep/.el-upload
      width 150px
      height 150px
      position relative
      border 1px solid #ccc

      .el-icon-plus
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)

      .logo
        width 148px
        height 148px

      .tip
        position absolute
        bottom 0
        left 0
        width 100%
        height 40px
        line-height 40px
        background-color rgba(0,0,0,.3)
        color #fff
        font-size 16px
        font-weight 600

  .logo
    width 150px
    height 150px

  .operate
    text-align center
    margin-top 40px

  /deep/.shop-logo-upload
    .el-form-item__content
      display flex
      align-items center
      margin-left 0 !impotant

  .c-9
    color #999
    margin-left 20px

.phone-input
  width 200px
  margin-right 20px
  margin-bottom 20px

.detail
  li
    padding 0 15px
    position relative

  .content
    font-size 14px
    color #333
    line-height 1.6
    margin-bottom 15px

  img
    max-width 100%
    width auto
    height 150px

.mr-10
  margin-right 10px
.ml-30
  margin-left 30px
.w-100
  width  100px
  /deep/.el-range-separator
    width 20px

.checkbox
  text-align left
  margin-left 20px

.mw-0 {
  min-width: 0
}
</style>
